import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AlertType } from './alert-type';
import * as i0 from "@angular/core";
import * as i1 from "@mhe/ngx-shared/translate";
import * as i2 from "@angular/common";
import * as i3 from "@mhe/ngx-shared/tooltip";
const _c0 = ["closeBtn"];
function AlertComponent_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3, 4);
    i0.ɵɵlistener("click", function AlertComponent_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.alertClose()); })("focus", function AlertComponent_button_5_Template_button_focus_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.onFocus()); })("blur", function AlertComponent_button_5_Template_button_blur_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onBlur()); });
    i0.ɵɵelementEnd();
} }
const _c1 = ["*"];
export class AlertComponent {
    constructor(translateService) {
        this.translateService = translateService;
        this.type = AlertType.Info;
        this.closable = true;
        /** @deprecated: Bootstrap 5 */
        this.smallAlert = false;
        this.suppressAnnouncement = false;
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.close = new EventEmitter();
        this.boundKeyDownFunc = this.onKeyDown.bind(this);
        this.typeDict = {
            'alert-info': 'Important',
            'alert-success': 'Success',
            'alert-warning': 'Warning',
            'alert-error': 'Error',
        };
    }
    get isCloseable() {
        return this.type !== AlertType.Error && this.closable;
    }
    alertClose() {
        window.removeEventListener('keydown', this.boundKeyDownFunc);
        this.close.emit();
    }
    onFocus() {
        window.addEventListener('keydown', this.boundKeyDownFunc);
    }
    onBlur() {
        window.removeEventListener('keydown', this.boundKeyDownFunc);
    }
    getAriaRole() {
        if (this.typeDict[this.type] === 'Error') {
            return 'alert';
        }
        else {
            return 'alert-dialog';
        }
    }
    focusCloseButton() {
        if (this.closeBtn) {
            setTimeout(() => {
                this.closeBtn.nativeElement.focus();
            }, 0);
        }
    }
    getAlertType(type) {
        return this.translateService.translate('ngx-shared-' + this.typeDict[type].toLowerCase());
    }
    onKeyDown(event) {
        if (event.key === 'Escape') {
            this.alertClose();
        }
    }
}
AlertComponent.ɵfac = function AlertComponent_Factory(t) { return new (t || AlertComponent)(i0.ɵɵdirectiveInject(i1.TranslateService)); };
AlertComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AlertComponent, selectors: [["mhe-alert"]], viewQuery: function AlertComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.closeBtn = _t.first);
    } }, inputs: { type: "type", closable: "closable", smallAlert: "smallAlert", suppressAnnouncement: "suppressAnnouncement" }, outputs: { close: "close" }, ngContentSelectors: _c1, decls: 6, vars: 9, consts: [[1, "alert", 3, "ngClass"], [1, "visually-hidden"], ["type", "button", "class", "btn-close", "mheTooltip", "Close", "placement", "bottom", 3, "click", "focus", "blur", 4, "ngIf"], ["type", "button", "mheTooltip", "Close", "placement", "bottom", 1, "btn-close", 3, "click", "focus", "blur"], ["closeBtn", ""]], template: function AlertComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0)(1, "span", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(4);
        i0.ɵɵtemplate(5, AlertComponent_button_5_Template, 2, 0, "button", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassProp("alert-dismissible", ctx.isCloseable);
        i0.ɵɵproperty("ngClass", ctx.type);
        i0.ɵɵattribute("aria-live", ctx.suppressAnnouncement ? "off" : "assertive")("role", ctx.suppressAnnouncement ? null : "alert");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 7, ctx.getAlertType(ctx.type)));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isCloseable);
    } }, dependencies: [i2.NgClass, i2.NgIf, i3.TooltipDirective, i2.AsyncPipe], styles: ["\n"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AlertComponent, [{
        type: Component,
        args: [{ selector: 'mhe-alert', template: "<div\n  class=\"alert\"\n  [ngClass]=\"type\"\n  [class.alert-dismissible]=\"isCloseable\"\n  [attr.aria-live]=\"suppressAnnouncement ? 'off' : 'assertive'\"\n  [attr.role]=\"suppressAnnouncement ? null : 'alert'\"\n>\n  <span class=\"visually-hidden\">{{ getAlertType(type) | async }}</span>\n  <ng-content></ng-content>\n\n  <button\n    *ngIf=\"isCloseable\"\n    #closeBtn\n    type=\"button\"\n    class=\"btn-close\"\n    mheTooltip=\"Close\"\n    placement=\"bottom\"\n    (click)=\"alertClose()\"\n    (focus)=\"onFocus()\"\n    (blur)=\"onBlur()\"\n  ></button>\n</div>\n", styles: ["/*# sourceMappingURL=alert.component.css.map */\n"] }]
    }], function () { return [{ type: i1.TranslateService }]; }, { type: [{
            type: Input
        }], closable: [{
            type: Input
        }], smallAlert: [{
            type: Input
        }], suppressAnnouncement: [{
            type: Input
        }], close: [{
            type: Output
        }], closeBtn: [{
            type: ViewChild,
            args: ['closeBtn']
        }] }); })();
